var path = 'common/components/spinner/spinner.html';
var html = "<div ng-if=\"$spinnerCtrl.isVisible()\" class=\"spinner\">\n  <div class=\"backdrop\">\n    <div class=\"message text-center\">\n      <img src='/assets/images/loading.gif' />\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./common/components/spinner/spinner.html
// module id = ./common/components/spinner/spinner.html
// module chunks = 0